import React, { useState } from 'react';
import PropertyMap from '../components/PropertyMap';
import PropertySidebar from '../components/PropertySidebar';

const PropertiesPage = () => {
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleAnalyze = async (propertyId) => {
    setIsAnalyzing(true);
    try {
      // Call the existing AI analysis endpoint
      const API_BASE = import.meta.env.VITE_API_URL || ''
      const response = await fetch(`${API_BASE}/api/v1/analyze/by-id/${propertyId}`, {
        method: 'POST'
      });
      const result = await response.json();
      
      // Handle result - maybe update sidebar with analysis results
      console.log('AI Analysis:', result);
      
      // Navigate to analysis dashboard with the result
      // or show analysis results in the sidebar
    } catch (error) {
      console.error('Analysis failed:', error);
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <div className="properties-page" style={{ display: 'flex', height: '100vh', width: '100vw' }}>
      <div style={{ flex: 1, position: 'relative' }}>
        <PropertyMap 
          onPropertySelect={setSelectedProperty}
          selectedProperty={selectedProperty}
        />
      </div>
      
      {selectedProperty && (
        <PropertySidebar 
          property={selectedProperty}
          onClose={() => setSelectedProperty(null)}
          onAnalyze={handleAnalyze}
        />
      )}
    </div>
  );
};

export default PropertiesPage;
